import { 
    DISALLOWED_PERIODS_CHANGE_MODE,
    DISALLOWED_PERIODS_BEGIN,
    FETCH_DISALLOWED_PERIODS_SUCCESS,
    CREATE_DISALLOWED_PERIODS_SUCCESS,
    EDIT_DISALLOWED_PERIODS_SUCCESS,
    DELETE_DISALLOWED_PERIODS_SUCCESS,
    DISALLOWED_PERIODS_FAILURE,
    DISALLOWED_PERIODS_SET_ERROR
} from '../actions/disallowedPeriodsActions'
import { pageModes } from '../_constants/emparkConstants'

const initialState = {
    disallowedPeriods: {
        rate: [],
        context: [],
        municipality: []
    },
    reference:null,
    referenceId:'',
    loading:false,
    error:null,
    hasFetched:false,
    router: {
        mode:pageModes.list,
        id:0
    }
}

export function disallowedPeriodsReducer(state = initialState, action) {
    switch (action.type) {
        case DISALLOWED_PERIODS_CHANGE_MODE:
            return {
                ...state,
                router: action.payload,
                error:null
            }
        case DISALLOWED_PERIODS_BEGIN:
            return {
                ...state,
                loading:true,
                error:null
            }
        case DISALLOWED_PERIODS_SET_ERROR:
            return {
                ...state,
                error:action.payload.error
            };
        case FETCH_DISALLOWED_PERIODS_SUCCESS:
            return {
                ...state,
                disallowedPeriods:action.payload.disallowedPeriods,
                reference:action.payload.reference,
                referenceId:action.payload.referenceId,
                loading:false,
                error:null
            }
        case CREATE_DISALLOWED_PERIODS_SUCCESS:
        case EDIT_DISALLOWED_PERIODS_SUCCESS:
            return {
                ...state,
                loading:false,
                error:null,
                router: {
                    mode:pageModes.list,
                    id:0
                }
            }
        case DELETE_DISALLOWED_PERIODS_SUCCESS:
            return {
                ...state,
                loading:false,
                error:null,
                hasFetched:true,
                router: {
                    mode:pageModes.list,
                    id:0
                }
            }
        case DISALLOWED_PERIODS_FAILURE:
            return {
                ...state,
                loading:false,
                error:action.payload.error
            }
        default:
            return state;
    }
}
// import {
//     FETCH_SPECIALDAYS_BEGIN,
//     FETCH_SPECIALDAYS_SUCCESS,
//     FETCH_SPECIALDAYS_FAILURE,
//     CREATE_SPECIALDAY_BEGIN,
//     CREATE_SPECIALDAY_SUCCESS,
//     CREATE_SPECIALDAY_FAILURE,
//     SAVE_SPECIALDAY_BEGIN,
//     SAVE_SPECIALDAY_SUCCESS,
//     SAVE_SPECIALDAY_FAILURE,
//     DELETE_SPECIALDAY_BEGIN,
//     DELETE_SPECIALDAY_SUCCESS,
//     DELETE_SPECIALDAY_FAILURE,
//     GET_SPECIALDAY_BEGIN,
//     GET_SPECIALDAY_SUCCESS,
//     GET_SPECIALDAY_FAILURE,
// } from '../actions/disallowedPeriodsActions';

// const initialState = {
//     items: [],
//     editFareObject: {
//         id: '',
//         name: '',
//         description: '',
//         fromDate: '',
//         toDate: '',
//     },
//     editDialog: false,
//     editDialogLoading: false,
//     editDialogError: null,
//     loading: false,
//     error: null
// }

// export function disallowedPeriodsReducer(state = initialState, action) {
//     switch (action.type) {
//         case FETCH_SPECIALDAYS_BEGIN:
//             return {
//                 ...state,
//                 loading: true,
//                 error: null
//             };
//         case FETCH_SPECIALDAYS_SUCCESS:
//             return {
//                 ...state,
//                 loading: false,
//                 items: action.payload.items
//             };
//         case FETCH_SPECIALDAYS_FAILURE:
//             return {
//                 ...state,
//                 loading: false,
//                 error: action.payload.error,
//                 items: []
//             };

//         case GET_SPECIALDAY_BEGIN:
//             return {
//                 ...state,
//                 editDialogLoading: true,
//                 error: null
//             };
//         case GET_SPECIALDAY_SUCCESS:
//             return {
//                 ...state,
//                 editDialogLoading: false,
//                 items: action.payload.items
//             };
//         case GET_SPECIALDAY_FAILURE:
//             return {
//                 ...state,
//                 editDialogLoading: false,
//                 error: action.payload.error,
//                 items: []
//             };

//         case CREATE_SPECIALDAY_BEGIN:
//             return {
//                 ...state,
//                 loading: true,
//                 editDialogLoading: true,
//                 error: null
//             };
//         case CREATE_SPECIALDAY_SUCCESS:
//             return {
//                 ...state,
//                 loading: false,
//                 editDialogLoading: false,
//                 specailDay: action.payload.disallowedPeriodObject
//             };
//         case CREATE_SPECIALDAY_FAILURE:
//             return {
//                 ...state,
//                 loading: false,
//                 editDialogLoading: false,
//                 error: action.payload.error
//             }
//         case SAVE_SPECIALDAY_BEGIN:
//             return {
//                 ...state,
//                 loading: true,
//                 editDialogLoading: true,
//                 error: null
//             };
//         case SAVE_SPECIALDAY_SUCCESS:
//             return {
//                 ...state,
//                 loading: false,
//                 editDialogLoading: false,
//                 specailDay: action.payload.disallowedPeriodObject
//             };
//         case SAVE_SPECIALDAY_FAILURE:
//             return {
//                 ...state,
//                 loading: false,
//                 editDialogLoading: false,
//                 error: action.payload.error
//             }
//         case DELETE_SPECIALDAY_BEGIN:
//             return {
//                 ...state,
//                 loading: true,
//                 editDialogLoading: true,
//                 error: null
//             };
//         case DELETE_SPECIALDAY_SUCCESS:
//             return {
//                 ...state,
//                 loading: false,
//                 editDialogLoading: false,
//                 specailDay: action.payload.disallowedPeriodObject
//             };
//         case DELETE_SPECIALDAY_FAILURE:
//             return {
//                 ...state,
//                 loading: false,
//                 editDialogLoading: false,
//                 error: action.payload.error
//             }
//         default:
//             return state;
//     }
// }

